var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipQues(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_6935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 7.30652C6.18672 6.77583 6.33603 6.25574 6.61817 5.80628C6.90031 5.35682 7.3038 4.99629 7.78208 4.76632C8.26035 4.53635 8.7939 4.44631 9.32115 4.50659C9.8484 4.56686 10.3478 4.775 10.7618 5.10698C11.1759 5.43896 11.4876 5.88125 11.661 6.3828C11.8344 6.88435 11.8625 7.42471 11.7419 7.94153C11.6214 8.45835 11.3572 8.93055 10.9798 9.3036C10.6024 9.67673 10.1272 9.93548 9.609 10.05C9.43905 10.0835 9.28575 10.1745 9.17483 10.3076C9.06398 10.4408 9.00225 10.608 9 10.7813V11.616",
    stroke: "black",
    strokeWidth: 0.583333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 17.6258C13.7635 17.6258 17.625 13.7642 17.625 9.00075C17.625 4.23728 13.7635 0.375732 9 0.375732C4.23655 0.375732 0.375 4.23728 0.375 9.00075C0.375 13.7642 4.23655 17.6258 9 17.6258Z",
    stroke: "black",
    strokeWidth: 0.583333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00146 13.8689C8.89789 13.8689 8.81396 13.785 8.81396 13.6814C8.81396 13.5779 8.89789 13.4939 9.00146 13.4939",
    stroke: "black",
    strokeWidth: 0.583333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00146 13.8689C9.10504 13.8689 9.18896 13.785 9.18896 13.6814C9.18896 13.5779 9.10504 13.4939 9.00146 13.4939",
    stroke: "black",
    strokeWidth: 0.583333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_6935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipQues);
export default __webpack_public_path__ + "static/media/tooltip-ques.a3fa2ae682d37a73dca93b32ad2edcc7.svg";
export { ForwardRef as ReactComponent };